module.exports = "/images/vendor/vue-paycard/src/troy.png?3a14bde39f455cc3c81f2f14bef0205c";